import toastMessage from '@components/Toast';
import { AxiosInstance } from 'axios';

import {
  GenericResponse,
  RunDeliverableMemosParams,
  ScheduleDeliverableParams,
} from 'pages/RunDeliverable/store/types';

export default class RunDeliverablesAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async scheduleDeliverable(
    payload: ScheduleDeliverableParams,
  ): Promise<GenericResponse> {
    const response = await this.client.post<GenericResponse>(
      '/v2/hedge-accounting/schedule-deliverable/',
      payload,
    );

    if (!response.data || typeof response.data.success !== 'boolean') {
      toastMessage.error('Invalid API response format');
    }

    return response.data;
  }

  async runDeliverableReports(
    payload: ScheduleDeliverableParams,
  ): Promise<GenericResponse> {
    const response = await this.client.post<GenericResponse>(
      '/v2/hedge-accounting/run-deliverable/',
      payload,
    );

    if (!response.data || typeof response.data.success !== 'boolean') {
      toastMessage.error('Invalid API response format');
    }

    return response.data;
  }

  async runDeliverableMemos(
    payload: RunDeliverableMemosParams,
  ): Promise<GenericResponse> {
    const response = await this.client.post<GenericResponse>(
      '/v2/reporting/download-hedge-designation-memo-report/',
      payload,
    );

    if (!response.data || typeof response.data.success !== 'boolean') {
      toastMessage.error('Invalid API response format');
    }

    return response.data;
  }
  async getJECurrenciesByEntity(entity_id?: string | number) {
    const response = await this.client.get(
      '/v2/hedging/transactions/currencies-by-entity/?entity_id=' + entity_id,
    );
    return response.data;
  }
}
